import { Component } from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'

import { trackEvent } from '../../../../common/services/intercom'
import { OldButton } from '../../../generic'
import FamilyPortalPaymentOptions from './FamilyPortalPaymentOptions'

interface FamilyPortalPaymentProps {
  fields: any
  data: any
  formId: string
  onComplete: (callback: () => void) => void
  setFormField: (args: { key: string; value: any }) => void
  goToNextStep?: () => void
  mixpanel: any // Define the type for mixpanel
}

export default class FamilyPortalPayment extends Component<FamilyPortalPaymentProps> {
  form: HTMLDivElement | null = null

  setFormRef = (node: HTMLDivElement | null) => (this.form = node)

  componentDidMount() {
    if (this.form) return this.form?.scrollIntoView()
  }

  handleSubmit = () => {
    const { goToNextStep, onComplete, mixpanel, fields } = this.props
    onComplete(goToNextStep!) // pass in goToNextStep as a callback
    trackEvent('CO_family_set_payment')
    mixpanel.track('CO_family_set_payment', {
      familyPaymentType: fields.familyPaymentType,
    })
  }

  render() {
    const {
      setFormField,
      fields,
      formId,
      data: { residents, homeName },
    } = this.props

    const activeResidents = residents.length
    const btnDisabled = !fields.familyPaymentType

    return (
      <div className={css(classes.container)}>
        <div style={{ height: 80 }} ref={this.setFormRef} />
        <h2 className={css(classes.header)}>Family Portal Setup</h2>
        <div className={css(classes.bodyText)}>
          Choose how you would like the billing to be set up for the {homeName}{' '}
          Family Portal.
        </div>
        <FamilyPortalPaymentOptions
          activeResidents={activeResidents}
          fields={fields}
          formId={formId}
          setFormField={setFormField}
        />
        <div className={css(classes.buttonBodyText)}>
          Note: The monthly bill will increase or decrease depending on the
          number of active profiles.
        </div>
        <OldButton
          onClick={() => !btnDisabled && this.handleSubmit()}
          disabled={btnDisabled}
          type="add"
          text="Complete Setup"
          style={styles.button}
        />
      </div>
    )
  }
}

const styles = {
  radioOptionStyle: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: '16px 18px 35px 16px',
    fontSize: 18,
    lineHeight: '32px',
  },
  button: {
    height: 40,
    marginTop: 19,
  },
}

const classes = StyleSheet.create({
  bodyText: {
    lineHeight: '22px',
  },
  buttonBodyText: {
    lineHeight: '22px',
    textAlign: 'center',
  },
  costImage: {
    height: 140,
    marginTop: 24,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 960,
    margin: 'auto',
  },
  header: {
    lineHeight: '36px',
    alignSelf: 'center',
    marginBottom: 24,
  },
  paymentOptionsContainer: {
    padding: '32px 0 50px 0',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
})
